<template>
  <section>
    <Toolbar />
    <div
      class="
        d-flex
        flex-column
        justify-center
        align-center
        mt-xs-5 mt-sm-5 mt-md-3 mt-lg-3 mt-xl-3
        mx-5
      "
    >
      <!-- <IconoHeader class="icono-header" icono="lock" /> -->
      <v-row
        justify="center"
        class="ma-0 pa-0 mt-5 mt-xs-5 mt-sm-5 mt-md-3 mt-lg-3 mt-xl-3"
      >
        <v-col cols="12" class="ma-0 pa-0">
          <h2 class="texto-titulo text-center font-weight-bold">
            Confirmemos que eres tú
          </h2>
        </v-col>
      </v-row>
      <v-row
        justify="center"
        class="ma-0 pa-0 mt-5 mt-xs-5 mt-sm-5 mt-md-3 mt-lg-3 mt-xl-3"
      >
        <v-col cols="12" class="ma-0 pa-0">
          <p
            class="text-body-2 text-center grey--text text--darken-2 ma-0 mx-3"
          >
            Ingresa el código de verificación que hemos enviado a tu celular
            terminación ******{{ celularOferta.slice(-4) }}
          </p>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0 mt-2">
        <v-col cols="11" xs="11" sm="8" md="8" lg="8" xl="8" class="ma-0 pa-0">
          <v-otp-input
            v-model="otp"
            class="seccion-otp"
            length="6"
            type="number"
            @keydown="verificarOTPEsNumerico"
            autocomplete="off"
          ></v-otp-input>
          <div class="d-flex flex-row justify-center align-center pa-0">
            <span class="text-body-2 grey--text text--darken-2">
              ¿No recibiste código?
            </span>
            <v-btn
              text
              color="primary"
              @click="reenviarOtp"
              :loading="cargandoReenvio"
              :disabled="cargandoReenvio || contador > 0"
              >{{ mensajeReenviar }}</v-btn
            >
          </div>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0 mt-2">
        <v-col cols="11" xs="11" sm="9" md="9" lg="9" xl="12" class="ma-0 pa-0">
          <v-sheet class="pa-3 rounded-lg grey lighten-3">
            <div class="text-body-2 font-weight-bold mb-2">
              🔔 Recomendaciones:
            </div>
            <v-row dense>
              <v-col cols="12" class="d-flex align-center">
                <v-icon color="green" small>mdi-whatsapp</v-icon>
                <span class="text-caption ml-2"
                  >Se paciente, el código es enviado vía WhatsApp y SMS y puede
                  demorar hasta 1 minuto.</span
                >
              </v-col>
              <v-col cols="12" class="d-flex align-center">
                <v-icon color="green" small>mdi-email</v-icon>
                <span class="text-caption ml-2"
                  >Revisa tu bandeja de SPAM.</span
                >
              </v-col>
              <v-col cols="12" class="d-flex align-center">
                <v-icon color="green" small>mdi-refresh</v-icon>
                <span class="text-caption ml-2"
                  >No le des atrás, eso cambia el código.
                </span>
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
      </v-row>
      <v-row
        justify="center"
        class="ma-0 pa-0 mt-5 mt-xs-5 mt-sm-5 mt-md-3 mt-lg-3 mt-xl-3"
      >
        <v-col cols="11" xs="11" sm="11" md="8" lg="8" xl="8" class="ma-0 pa-0">
          <v-checkbox v-model="sonTerminosAceptados" class="ma-0 pa-0">
            <template v-slot:label>
              <div class="text-body-2 text-center ma-0 pa-0">
                Revisé los
                <a @click="verTerminos('/terminos-y-condiciones')"
                  >Términos y Condiciones</a
                >
                y
                <a @click="verTerminos('/aviso-de-privacidad')"
                  >Aviso de privacidad</a
                >
              </div>
            </template>
          </v-checkbox>
        </v-col>
        <v-col cols="11" xs="11" sm="11" md="8" lg="8" xl="8" class="ma-0 pa-0">
          <v-checkbox v-model="sonTerminosBuroAceptados" class="ma-0 pa-0">
            <template v-slot:label>
              <div class="text-body-2 text-center ma-0 pa-0">
                Acepto la consulta de mi
                <a @click="verTerminos('/terminos-buro')">Buró de Crédito</a>
              </div>
            </template>
          </v-checkbox>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0 mt-2">
        <v-col cols="12" class="ma-0 pa-0">
          <v-btn
            class="align-self-center"
            color="primary"
            elevation="3"
            :disabled="!esPermitidoContinuar || cargandoValidacion"
            :loading="cargandoValidacion"
            @click="submit"
            >Continuar<v-icon right light>mdi-arrow-right</v-icon></v-btn
          >
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Toolbar from '@/components/compartidos/Toolbar.vue'
// import IconoHeader from '@/components/compartidos/IconoHeader.vue'
import OtpService from '@/servicios/otp'
import {
  KEYS_VALIDAS_OTP,
  ALERTA_ERROR,
  ID_PROCESO_CREDITO_DIGITAL_CONSUMO,
} from '@/utilidades/utilidades'
import { InsertaLogMixin } from '@/mixins/credito/InsertaLog.mixin'

export default {
  name: 'VerificacionOTP',
  components: {
    Toolbar,
    // IconoHeader,
  },
  mixins: [InsertaLogMixin],
  data: () => ({
    esOtpValido: false,
    cargandoReenvio: false,
    cargandoValidacion: false,
    contador: 30,
    interval: null,
    otpErr: 'e',
    intentoReenvio: 1,
    celularOferta: '',
  }),
  mounted() {
    this.InsertaLog()
  },
  created() {
    this.$store.commit('ESTABLECER_LAYOUT', 'Layout')
    // this.establecerLector()
    this.contador = 60
    this.interval = setInterval(() => {
      if (this.contador <= 0) {
        clearInterval(this.interval)
      }
      this.contador -= 1
    }, 1000)
    this.celularOferta = this.$store.getters['persona/obtenerCelularOferta']
  },
  computed: {
    mensajeReenviar() {
      return this.contador <= 0 ? 'Reenviar código' : 'Espere  ' + this.contador
    },
    otp: {
      get() {
        return this.obtenerOtpInicio
      },
      set(value) {
        this.actualizaOTP({ otpInicio: value })
      },
    },
    sonTerminosAceptados: {
      get() {
        return this.obtenerSonTerminosAceptados
      },
      set(value) {
        this.setSonTerminosAceptados(value)
      },
    },
    sonTerminosBuroAceptados: {
      get() {
        return this.obtenerSonTerminosBuroAceptados
      },
      set(value) {
        this.setSonTerminosBuroAceptados(value)
      },
    },
    esPermitidoContinuar() {
      if (
        this.otp.length === 6 &&
        Number.isInteger(parseInt(this.otp)) &&
        this.sonTerminosAceptados &&
        this.sonTerminosBuroAceptados
      ) {
        return true
      } else {
        return false
      }
    },
    ...mapGetters({
      obtenerOtpInicio: 'credito/obtenerOtpInicio',
      obtenerSonTerminosAceptados: 'credito/obtenerSonTerminosAceptados',
      obtenerSonTerminosBuroAceptados:
        'credito/obtenerSonTerminosBuroAceptados',
    }),
  },
  methods: {
    verTerminos(ruta) {
      this.$router.push(ruta)
    },
    async submit() {
      const esOtpCorrecto = await this.validarOtp()
      // console.log(esOtpCorrecto, 'res')
      if (!esOtpCorrecto) {
        this.InsertaLog({
          exception_error: 'FALLO INTENTO DE VALIDAR OTP',
          notas: this.otp.toString(),
        })
        return
      }
      this.actualizaOTP({ otpInicio: '' })
      // this.$router.push('parametrizacion')
      if (
        this.$store.getters['credito/obtenerCredito'].tipoProcesoCredito ==
        ID_PROCESO_CREDITO_DIGITAL_CONSUMO
      ) {
        this.$router.push('datosDomicilio')
      } else {
        this.$router.push('beneficios')
      }
    },
    async establecerLector() {
      this.otpErr = 'jalowin'
      // const leread =
      const ac = new AbortController()
      navigator.credentials
        .get({
          otp: { transport: ['sms'] },
          signal: ac.signal,
        })
        .then((otp) => {
          this.otp = otp.code
          this.otpErr = otp.code
          // if (form) form.submit();
        })
        .catch((err) => {
          console.log(err)
          this.otpErr = err
        })
    },
    verificarOTPEsNumerico(event) {
      if (!KEYS_VALIDAS_OTP.includes(event.key)) {
        event.preventDefault()
      }
    },
    async reenviarOtp() {
      this.contador = 60
      this.$store.dispatch('persona/establecerIntentosEnviarOTP')
      this.interval = setInterval(() => {
        if (this.contador <= 0) {
          clearInterval(this.interval)
        }
        this.contador -= 1
      }, 1000)
      let result
      this.otp = ''
      const reenviarOtpRequest =
        this.$store.getters['persona/obtenerEnviarOtpRequest']
      try {
        this.cargandoReenvio = true
        result = await OtpService.ReenviarOtp(reenviarOtpRequest)
        if (result.data.Codigo != 200 && result.data.Modelo != true) {
          this.enviarAlertaError(
            result.data.Mensaje,
            ALERTA_ERROR.tiempo,
            ALERTA_ERROR.visible
          )
        }
        this.cargandoReenvio = false
      } catch (error) {
        this.enviarAlertaError(
          ALERTA_ERROR.mensaje,
          ALERTA_ERROR.tiempo,
          ALERTA_ERROR.visible
        )
        this.cargandoReenvio = false
      }
    },
    async validarOtp() {
      let esOtpCorrecto = false
      const validaOtpRequest =
        this.$store.getters['persona/obtenerValidaOtpRequest']
      let result
      try {
        this.cargandoValidacion = true
        result = await OtpService.ValidaOtp(validaOtpRequest)
        if (
          (result.data.Codigo == 200 && result.data.Estado == true) ||
          result.data.Modelo === 'Codigo validado con exito'
        ) {
          esOtpCorrecto = true
        } else {
          this.enviarAlertaError({
            mensaje: result.data.Mensaje,
            tiempo: ALERTA_ERROR.tiempo,
            visibilidad: ALERTA_ERROR.visible,
          })
        }
        this.cargandoValidacion = false
      } catch {
        this.enviarAlertaError({
          mensaje: ALERTA_ERROR.mensaje,
          tiempo: ALERTA_ERROR.tiempo,
          visibilidad: ALERTA_ERROR.visible,
        })
        this.cargandoValidacion = false
      }
      return esOtpCorrecto
    },
    ...mapActions({
      enviarAlertaError: 'alerta/enviarAlertaError',
      actualizaOTP: 'credito/actualizaOtp',
      setSonTerminosAceptados: 'credito/setSonTerminosAceptados',
      setSonTerminosBuroAceptados: 'credito/setSonTerminosBuroAceptados',
    }),
  },
}
</script>
